module.exports = __webpack_public_path__ + "img/AutoMode.6065b86a.svg";